import axios from 'axios';
import queryClient, { PERSIST_KEY } from '@/lib/queryClient';
import { authClient } from './authClient';

const VITE_API_URL = import.meta.env.VITE_API_URL;

const apiClient = axios.create({
  baseURL: `${VITE_API_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

let redirectingToLogin = false;

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      const onLoginPage = window.location.pathname.startsWith('/login');
      if (!onLoginPage && !redirectingToLogin) {
        const hasSession = await authClient
          .getSession()
          .then(({ data }) => !!data?.user)
          .catch(() => false);
        if (!hasSession && !redirectingToLogin) {
          redirectingToLogin = true;
          queryClient.clear();
          window.localStorage.removeItem(PERSIST_KEY);
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
